module.exports = __webpack_public_path__ + "public/1.0.1_896977/img/excel.a5ca0da0.svg";